export enum ReferralTokenType {
	Rfx = 1,
	RfxPreApproval = 2,
	SharedProfile = 3,
	EvaluationPanelMember = 4,
}

export enum ReferralTokenQueryParams {
	Rfx = "rit",
	SharedProfile = "sc",
	TokenType = "token_type",
}

export enum LoginPath {
	NoPathChosen = 0,
	CreateAccount = 1,
	Login = 2,
}
